const setSessionStorage = (key: string, value: string): void => {
  sessionStorage.setItem(key, value);
  return;
};

const getSessionStorage = (key: string, defaultValue: string = ""): string => {
  const value = sessionStorage.getItem(key);
  return value || defaultValue;
};

const setLocalStorage = (key: string, value: string): void => {
  localStorage.setItem(key, value);
  return;
};

const getLocalStorage = (key: string, defaultValue: string = ""): string => {
  const value = localStorage.getItem(key);
  return value || defaultValue;
};

export {
  setSessionStorage,
  getSessionStorage,
  setLocalStorage,
  getLocalStorage,
};
